import React from 'react';

import StyledButton from '@src/components/wysiwyg_editor/page_content_items/control_panels/StyledButton';
import backwardImg from '@images/wysiwyg_editor/control_panels/backward.svg';
import backwardHoverImg from '@images/wysiwyg_editor/control_panels/backward-hover.svg';

type TProps = {
  onClick: () => void;
};

function Backward(props: TProps) {
  return (
    <StyledButton
      image={backwardImg as string}
      hoverImage={backwardHoverImg as string}
      onClick={props.onClick}
    >
      Back
    </StyledButton>
  );
}

export default Backward;
